import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { ApiService } from '../api.service';
import { ApiResponse } from '../api-response-models';
import { HttpEvent } from '@angular/common/http';

@Injectable()
export class DashboardService {

    constructor(
        private apiService: ApiService) {

    }

    getUrl(): Observable<ApiResponse<string>> {
        return this.apiService.get('dashboard/dashboard-url', {});
    }

    getDashboardOptions(): Observable<ApiResponse<string>> {
        return this.apiService.get('dashboard/dashboard-options', {});
    }

    refreshDashboard(refresh: number): Observable<ApiResponse<{id: number, lastRefresh: Date}>> {
        return this.apiService.get(`dashboard/refresh`, {refresh});
    }
}



// WEBPACK FOOTER //
// ./src/app/client-core/services/dashboard.service.ts